import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CreateOperatorForm } from "./create-operator-form";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export function CreateOperatorButton() {
  const [isOpen, setIsOpen] = useState(false);

  const onSuccess = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="default">Create Operator</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create Operator</DialogTitle>
        </DialogHeader>
        <CreateOperatorForm onSuccess={onSuccess} />
      </DialogContent>
    </Dialog>
  );
}
